<template>
    <div>
        <PageHeader type="Collection" title="Just added">
            <template #meta>The newest songs on Heesify</template>
        </PageHeader>

        <TrackList v-if="justadded && justadded.length" :songs="justadded" :ad-after="[4, 24]" header />

        <div v-else-if="!justadded" class="space-y-2">
            <div v-for="i in 8" :key="i" class="h-12 animate-pulse rounded-md bg-white/[0.03]"></div>
        </div>

        <p v-else class="py-16 text-center text-nomad-400">No recently added songs.</p>
    </div>
</template>
<script>
import { defineAsyncComponent } from 'vue'
import { Link, usePage } from "@inertiajs/vue3";
import { mapState, mapActions, mapGetters } from "vuex";
import JustAdded from "@/components/JustAdded.vue";
import PageHeader from "@/components/ui/PageHeader.vue";
import TrackList from "@/components/ui/TrackList.vue";
import { JustAddedPlaceholder } from "@/components/placeholders/placeholder.js";
const page = usePage();

export default {
    created() {
        this.getAllJustAdded();
    },
    methods: {
        ...mapActions("justadded", ["getAllJustAdded"]),
    },
    computed: {
        ...mapState({ justadded: (state) => state.justadded.all }),
    },
    components: {
        PageHeader,
        TrackList,
        JustAdded,
        JustAddedPlaceholder,
    },
    beforeMount() {
        document.title = page.props.title
    },
}
</script>